import { useMemo } from "react";
import { useLocation } from "react-router-dom";

type TopLevelRoute =
  | undefined
  | "person"
  | "firma"
  | "kursus"
  | "linje"
  | "admin"
  | "efteruddannelse";
export function useRouter() {
  const { search, pathname } = useLocation();
  const appRoot = pathname.split("/")[1];
  const isPerson = appRoot === "person";
  const isFirma = appRoot === "firma";
  const isKursus = appRoot === "kursus";
  const isLinje = appRoot === "linje";
  const isAdmin = appRoot === "admin";
  const isEfteruddannelse = appRoot === "efteruddannelse";
  const topLevelRoute: TopLevelRoute = isPerson
    ? "person"
    : isFirma
      ? "firma"
      : isKursus
        ? "kursus"
        : isLinje
          ? "linje"
          : isAdmin
            ? "admin"
            : isEfteruddannelse
              ? "efteruddannelse"
              : undefined;
  return {
    topLevelRoute,
    appRoot,
    searchQuery: useMemo(() => new URLSearchParams(search), [search]),
  };
}
